import { useEffect, useState } from 'react';
import axios from 'axios';
import React, { Component } from 'react';


import { Link } from 'react-router-dom';
import CanvasJSReact from '@canvasjs/react-charts';

import { useLocation, useNavigate } from 'react-router-dom';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';

import { Pie } from 'react-chartjs-2';
ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

//var CanvasJSReact = require('@canvasjs/react-charts');

var CanvasJS = CanvasJSReact.CanvasJS;
var CanvasJSChart = CanvasJSReact.CanvasJSChart;


// Function to generate random colors
function generateRandomColor() {
    const letters = "0123456789ABCDEF";
    let color = "#";
    for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
}

const PieChart = ({ gridData, twoTableColumnsCombined, selectedCombinedColumns,
    selectedIdsCombinedColumns, selectedLabelType,
    connectionNameValue, reportName, indexPie, xandLabelPieColumns }) => {


    const navigate = useNavigate();
    const location = useLocation();
    const [iframeUrl, setIframeUrl] = useState('');
    console.log(JSON.stringify(location.state) + "location.state--------------");

    let selectedCombinedColumnsValue = '';
    let selectedIdsCombinedColumnsValue = '';
    let selectedLabelTypeValue = '';
    let connectionName = '';
    let reportNameValue = '';
    let gridDataValue = '';
    let twoTableColumnsCombinedValue = '';
    let indexPieValue = null;
    let xandLabelPieColumnsValue = '';

    const [pieDataSet, setPieDataSet] = useState([]);
    const [xaxis, setXaxis] = useState([]);
    const [yaxis, setYaxis] = useState([]);

    if (location.state && location.state.selectedCombinedColumns !== undefined) {
        const { gridData, selectedCombinedColumns, selectedIdsCombinedColumns, selectedLabelType,
            connectionNameValue, reportName, twoTableColumnsCombined, xandLabelPieColumns } = location.state;

        console.log(selectedCombinedColumns); // Output: "name"
        console.log(selectedIdsCombinedColumns); // Output: "id"
        console.log(selectedLabelType); // Output: "Name Only"

        selectedCombinedColumnsValue = selectedCombinedColumns;
        selectedIdsCombinedColumnsValue = selectedIdsCombinedColumns;
        selectedLabelTypeValue = location.state.selectedLabelType;
        connectionName = connectionNameValue;
        reportNameValue = reportName;
        twoTableColumnsCombinedValue = twoTableColumnsCombined;
        gridDataValue = gridData;
        xandLabelPieColumnsValue = xandLabelPieColumns;

        console.log(JSON.stringify(selectedCombinedColumnsValue) + "selectedCombinedColumnsValueLOC"
            + JSON.stringify(selectedIdsCombinedColumnsValue) + "selectedIdsCombinedColumnsValueLOC"
            + JSON.stringify(selectedLabelTypeValue) + "selectedLabelTypeValueLOC");
    } else {
        console.log(JSON.stringify(gridData) + "gridData");

        selectedCombinedColumnsValue = selectedCombinedColumns;
        selectedIdsCombinedColumnsValue = selectedIdsCombinedColumns
        selectedLabelTypeValue = selectedLabelType;
        connectionName = connectionNameValue;
        reportNameValue = reportName;
        gridDataValue = gridData;
        twoTableColumnsCombinedValue = twoTableColumnsCombined;
        indexPieValue = indexPie;
        xandLabelPieColumnsValue = xandLabelPieColumns;


        console.log(JSON.stringify(twoTableColumnsCombinedValue) + "twoTableColumnsCombinedValue");
        console.log(JSON.stringify(selectedCombinedColumns) + "selectedCombinedColumns");
        console.log(JSON.stringify(selectedIdsCombinedColumns) + "selectedIdsCombinedColumns");
        console.log(JSON.stringify(selectedLabelType) + "selectedLabelType");
        console.log(JSON.stringify(selectedCombinedColumnsValue) + "selectedCombinedColumnsValue"
            + JSON.stringify(selectedIdsCombinedColumnsValue) + "selectedIdsCombinedColumnsValue"
            + JSON.stringify(selectedLabelTypeValue) + "selectedLabelTypeValue");

        console.log(JSON.stringify(xandLabelPieColumnsValue) + "xandLabelPieColumnsValue");


    }

    const handleClick = () => {
        console.log('Pie chart clicked!');

        navigate('/pieChart', { state: { selectedCombinedColumns, selectedIdsCombinedColumns, selectedLabelType } });
    };



    const [data, setData] = useState({
        labels: [],
        datasets: [],
    });

    useEffect(() => {
        const pieChartData = gridDataValue.map((data) => ({
            y: data[xandLabelPieColumnsValue.indexOf(selectedIdsCombinedColumnsValue)],
            label: data[xandLabelPieColumnsValue.indexOf(selectedCombinedColumnsValue)],
            color: generateRandomColor()
        }));

        // Now, pieChartData contains the data in the desired format
        console.log(JSON.stringify(pieChartData) + "pieChartData");

        setPieDataSet(pieChartData);
        console.log(JSON.stringify(pieDataSet) + "pieDataSet");



    },
        [selectedCombinedColumns, selectedIdsCombinedColumns, selectedLabelType])
    console.log("pieDatasetOUT :" + JSON.stringify(pieDataSet));
    const options = {
        exportEnabled: true,
        animationEnabled: true,
        title: {
            text: "Website Traffic Sources"
        },
        data: [{
            type: "pie",
            startAngle: 75,
            toolTipContent: "<b>{label}</b>: {y}%",
            showInLegend: "true",
            legendText: "{label}",
            indexLabelFontSize: 16,
            indexLabel: "{label} - {y}%",
            dataPoints: pieDataSet
            // dataPoints: [
            // 	{ y: 18, label: "Direct" },
            // 	{ y: 49, label: "Organic Search" },
            // 	{ y: 9, label: "Paid Search" },
            // 	{ y: 5, label: "Referral" },
            // 	{ y: 19, label: "Social" }
            // ]
        }

        ]

    }
    return (

        <div className="chart" style={location.state ? { width: '99%', height: '500px' } : { width: '50%', height: '300px' }}>
            <div className="pieDoughnut">

                {location.state || gridDataValue.length > 0 ? (
                    <>
                        {/* <h2>Connection Name : {connectionName}</h2> */}
                        {/* <h3>Report Name : {reportNameValue}</h3> */}
                        <Link to="/QueryBuilder" state={{ connectionName: connectionName, reportName: reportNameValue }}>Home</Link>
                        {/* <Pie data={data} options={options} /> */}
                        <CanvasJSChart data={data} options={options} />
                    </>

                ) : (
                    <CanvasJSChart data={data} options={options} onClick={() => handleClick()} />
                    // <Pie data={data} className="left-align" options={options}

                    //     onClick={() => handleClick()} />

                )}

            </div>
        </div>
    )

}
export default PieChart; 